var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPitcairnIslands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.0001H15.9996C15.9996 15.9857 15.9996 15.9717 15.9996 15.9572C15.9853 15.9716 15.9711 15.9858 15.9568 16.0001Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9857 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.08682C5.59271 3.51176 3.51228 5.59213 2.0874 8.09457V15.9999H6.26134V6.26089V6.26076H16.0005C16.0005 4.94432 16.0005 3.6902 16.0005 2.08682H8.09515Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 14.0325L10.3159 8.34793H8.34839V8.34806L16.0005 16.0001H16.0006C16.0006 16.0001 16.0006 14.6434 16.0006 14.0325V14.0325Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0434 9.7393L22.9564 10.435L20.8695 9.7393L20.1738 8.00018L20.8695 6.26105H25.0434L24.3477 8.00018L25.0434 9.7393Z",
    fill: "#ACABB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 9.73895V17.3911C18.0874 21.1186 22.957 22.2607 22.957 22.2607C22.957 22.2607 27.8265 21.1186 27.8265 17.3911V9.73895H18.0874Z",
    fill: "#338AF3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5259 19.2044C19.7229 21.5024 22.9565 22.2611 22.9565 22.2611C22.9565 22.2611 26.1901 21.5024 27.3871 19.2044L22.9565 11.8264L18.5259 19.2044Z",
    fill: "#6DA544"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8265 17.3138L22.957 9.73895L18.0874 17.3138V17.3911C18.0874 18.0809 18.2545 18.6821 18.5263 19.2039L22.957 12.3118L27.3876 19.2039C27.6594 18.6819 27.8265 18.0809 27.8265 17.391V17.3138Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitcairnIslands);
export default __webpack_public_path__ + "static/media/pitcairn-islands.345951c3.svg";
export { ForwardRef as ReactComponent };